


































import {
  Vue,
  Component,
} from "@/shared/vuepack";

import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {}
})
export default class DeductibleTrackerSettings extends Vue {
  featureFlagStore = useFeatureFlagStore();
}
